import React, { useState } from 'react'
import { Table } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import DeleteModal from '../DeleteModal';
import UserChangePassword from './UserChangePassword';
import UserAdd from './UserAdd';
import UserEdit from './UserEdit';
import { requestHandler } from '../../helper';
import { editUser } from '../../controller';
import { toast } from 'react-toastify';
import { exportUserFile } from '../../controller';
function UserTable({ userData, searchQuery, handleSearchChange, onStatusChange, perPage, page, getAllUsers, setPage, onPremiumChange, isPremium, onPlanChange, plan, status }) {

    const [selectedStatus, setSelectedStatus] = useState('all');
    const [selectedPlan, setSelectedPlan] = useState('all');
    const [selectedPremium, setSelectedPremium] = useState('all');

    const handleStatusSelect = (newStatus) => {
        setSelectedStatus(newStatus);
        onStatusChange(newStatus === 'all' ? '' : newStatus);
    };
    const handleIsPremiumSelect = (newIsPremium) => {
        setSelectedPremium(newIsPremium);
        onPremiumChange(newIsPremium === 'all' ? '' : newIsPremium);
    }


    const handlePlanSelect = (newPlan) => {
        setSelectedPlan(newPlan);
        onPlanChange(newPlan === 'all' ? '' : newPlan);
    }


    const onSuccessData = () => {
        if (userData.length === 1 && page > 1) {
            setPage(page - 1)
        } else {
            getAllUsers(perPage, page, searchQuery, isPremium)
        }
    }

    const handleEditUser = async (updatedData, itemId) => {
        await requestHandler(
            () => editUser(updatedData, itemId),  // Only pass the updated field
            null,
            (res) => {
                toast.success(res.message);
                onSuccessData();  // Handle success
            },
            () => { }  // Handle error (optional)
        );
    };


    const handleDownload = async () => {
        try {
            const res = await exportUserFile(); // Call the updated function
            const url = URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.download = `UserManagement.xlsx`; // Set the file name and extension
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Free up memory
            toast.success("Success! Your file has been downloaded");
        } catch (error) {
            console.error('Download error:', error);
            toast.error("Download failed");
        }
    };

    return (
        <>
            <div className="card-header border-0 p-0 pb-3">
                <div className='row g-4'>
                    <div className="col-12 col-xl-4">
                        <div className='form-control search-bar py-0 px-0'>
                            <div className='search-box'>
                                <img src="./images/png/seach-icon.png" width={13.81} height={13.81} alt="" />
                            </div>
                            <input type="text" className='form-control rounded-start-0 border-0' placeholder='Search here' value={searchQuery} onChange={handleSearchChange} />
                        </div>
                    </div>

                    <div className="col-12 col-xl-8">
                        <div className='d-flex flex-wrap justify-content-end align-items-center gap-3'>
                            <Dropdown className='status-btn'>
                                <Dropdown.Toggle variant="success" id="dropdown-basic" className={isPremium ? '' : 'text_light'}>
                                    {isPremium === '' ? 'Premium' : isPremium ? 'Yes' : 'No'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handleIsPremiumSelect('all')} className={selectedPremium === 'all' ? 'selected-status' : ''}>All</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleIsPremiumSelect('true')} className={selectedPremium === 'true' ? 'selected-status' : ''}>Yes</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleIsPremiumSelect('false')} className={selectedPremium === 'false' ? 'selected-status' : ''}>No</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                            <Dropdown className='status-btn'>
                                <Dropdown.Toggle variant="success" id="dropdown-basic" className={plan ? '' : 'text_light'}>
                                    {/* {plan || 'Select Plan'} */}
                                    {plan === 'basic' ? 'Basic' : plan === 'standard' ? 'Standard' : plan === 'premium' ? 'Premium' : 'Select Plan'}

                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handlePlanSelect('all')} className={selectedPlan === 'all' ? 'selected-status' : ''} >All Plans</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handlePlanSelect('basic')} className={selectedPlan === 'basic' ? 'selected-status' : ''}>Basic</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handlePlanSelect('standard')} className={selectedPlan === 'standard' ? 'selected-status' : ''}>Standard</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handlePlanSelect('premium')} className={selectedStatus === 'premium' ? 'selected-status' : ''}>Premium</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                            <Dropdown className='status-btn'>
                                <Dropdown.Toggle variant="success" id="dropdown-basic" className={status ? '' : 'text_light'}>
                                    {selectedStatus === 'all' ? 'Select Type' : selectedStatus === 'false' ? 'Deactive' : 'Active'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => handleStatusSelect('all')} className={selectedStatus === 'all' ? 'selected-status' : ''}>All</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleStatusSelect('true')} className={selectedStatus === 'true' ? 'selected-status' : ''}>Active</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleStatusSelect('false')} className={selectedStatus === 'false' ? 'selected-status' : ''}>Deactive</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <UserAdd getAllUsers={getAllUsers} />
                            <button className='add-btn' onClick={() => handleDownload()}>
                                <p className='m-0'>Export file</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className='overflow-auto-lg'>
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>No </th>
                            <th>User Name </th>
                            <th>E-mail </th>
                            <th className='text-center'>Premium</th>
                            <th className='text-center'>Plan</th>
                            <th className='text-center'>Status</th>
                            <th style={{ width: '180px', }} className='text-center'>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userData.length > 0 ? (
                            userData.map((item, index) => (
                                <tr key={index}>
                                    <td>{(page - 1) * perPage + index + 1}.</td>
                                    <td>{item.userName}</td>
                                    <td>{item.email}</td>
                                    <td className='text-center text-capitalize'>{item.isPremium ? 'Yes' : 'No'}</td>
                                    {/* <td className='text-center'>
                                        <div className='d-flex justify-content-center'>
                                            <Dropdown className='status-btn active all-drop'>
                                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                    {item.isPremium ? 'Yes' : 'No'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => handleEditUser({ isPremium: true }, item._id)} className={item.isPremium === true ? 'selected-status' : ''}>Yes</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleEditUser({ isPremium: false }, item._id)} className={item.isPremium === false ? 'selected-status' : ''}>No</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </td> */}
                                    {/* <td>{item.plan === '3' ? 'Basic' : item.plan === '6' ? 'Standard' : item.plan === '12' ? 'Premium' : 'Not Purchased'}</td> */}
                                    <td className='text-center text-capitalize'>{item.plan !== null ? item.plan : 'Not Purchased'}</td>
                                    {/* <td>
                                        <div className='d-flex justify-content-center'>
                                            <Dropdown className='status-btn active all-drop'>
                                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                    {console.log(item.plan)}

                                                    {item.plan || 'Select Plan'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => handleEditUser({ plan: 'MONTHLY' }, item._id)} className={item.plan === 'MONTHLY' ? 'selected-status' : ''}>Monthly</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleEditUser({ plan: 'YEARLY' }, item._id)} className={item.plan === 'YEARLY' ? 'selected-status' : ''}>Yearly</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleEditUser({ plan: 'ONE_TIME' }, item._id)} className={item.plan === 'ONE_TIME' ? 'selected-status' : ''}>One Time</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </td> */}
                                    <td className='text-center'>
                                        <div className='d-flex justify-content-center'>
                                            <Dropdown className='status-btn active all-drop'>
                                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                    {item.status ? 'Active' : 'Deactive'}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => handleEditUser({ status: true }, item._id)} className={item.status === true ? 'selected-status' : ''}>Active</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleEditUser({ status: false }, item._id)} className={item.status === false ? 'selected-status' : ''}>Deactive</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </td>
                                    <td style={{ width: '180px', }} >
                                        <div className='d-flex justify-content-center align-items-center gap-2 actions-image'>
                                            <UserChangePassword id={item._id} getAllUsers={getAllUsers} />
                                            <UserEdit id={item._id} userData={userData} getAllUsers={getAllUsers} />
                                            <DeleteModal title={"User Details"} id={item._id} endPoint={`/admin/delete-user`} onSuccess={onSuccessData} />
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={7} className='text-center py-3'>
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </>
    )
}

export default UserTable